import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
export default {
  methods: {
    updateCalendar: function updateCalendar(integrationCode, val) {
      var _this = this;

      this.showLoading();
      return this.$axios.post('/integrations/' + integrationCode + '/calendar', {
        calendar_id: val
      }).then(function (result) {
        _this.hideLoading();

        _this.$q.notify({
          message: _this.$t('mixins.your_calendar_has_been_updated'),
          type: 'positive'
        });

        _this.selected = val;
      }).finally(function () {
        _this.hideLoading();
      });
    },
    getCalendarList: function getCalendarList(integrationCode) {
      return this.$axios.get('/integrations/' + integrationCode + '/calendars').then(function (result) {
        // switch (integrationCode) {
        //   case 'googlecalendar':
        //     result.data = result.data.items.map((calendar) => {
        //       return {
        //         id: calendar.id,
        //         name: calendar.summary
        //       }
        //     })
        //     break
        // }
        return result.data;
      });
    }
  }
};